var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefinance = function SvgRefinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refinance_svg__a)",
    fillRule: "evenodd",
    d: "M1.54 10a8.46 8.46 0 1 1 16.919 0 8.46 8.46 0 0 1-16.92 0Zm4.72-2.36a1.377 1.377 0 1 1 2.755 0 1.377 1.377 0 0 1-2.754 0Zm4.723 4.721a1.377 1.377 0 1 1 2.754 0 1.377 1.377 0 0 1-2.754 0Zm-4.132.787a.787.787 0 0 0 1.113 0l5.183-5.183a.787.787 0 1 0-1.113-1.113l-5.183 5.183a.787.787 0 0 0 0 1.113Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "refinance_svg__a",
    x1: 4.14,
    x2: 19.203,
    y1: 16.819,
    y2: 2.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1B8"
  })))));
};
export default SvgRefinance;